module.exports = __webpack_public_path__ + "assets/6faed8cc922448084443d4be89a463f2.jpg";